import styled from 'styled-components';

export const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
